import http from "./HttpService";
import { API_BASE_CONTENT } from "../../constants/index";
import { getVersionId } from "modules/EmailBrowser/utils";
import { getCSRFToken } from "../../utils";

export function getWhnArticlesService(limit: number, offset: number) {
  let versionId = getVersionId();
  return http.get(
    API_BASE_CONTENT + `whats_happening_now_articles/?limit=${limit}&offset=${offset}&version_id=${versionId}`,
    { headers: { "X-CSRFToken": getCSRFToken() } }
  );
}

export function clearAllCurationService(versionId: number) {
  let payload = new FormData();
  payload.append("version_id", versionId.toString());
  return http.post(API_BASE_CONTENT + `delete_all_curated_articles/`, payload);
}

export function removeSingleArticleFromCurationService(versionId: number, articleId: number) {
  let payload = new FormData();
  payload.append("version_id", versionId.toString());
  payload.append("article_id", articleId.toString());
  return http.post(API_BASE_CONTENT + `delete_curated_article/`, payload);
}
